import { userConstants } from "../../../constants/userConstant";
import { postApi, getApi } from "../../../services/helpers/apiCall";
import moment from "moment";

const getStartEndDate = async (createdAtString, rangeType, range) => {
  const formatString = "YYYY-MM-DDTHH:mm:ss.SSSZ";
  const date = moment(createdAtString, formatString);
  const userCreatedAt = date.format("MM-DD-YYYY");
  // create a new moment object for the userCreatedAt date
  const startDate = moment(userCreatedAt, "MM-DD-YYYY");

  // add the specified range to the start date to get the end date
  const endDate = startDate.clone().add(range, rangeType);
  // format the end date as "MM-DD-YYYY"
  const userEndAt = endDate.format("MM-DD-YYYY");
  return {
    startDate: userCreatedAt,
    endDate: userEndAt,
  };
};

// action for login user
const login =
  ({ email, password }) =>
  (dispatch) => {
    dispatch(request({ email }));
    let apiCallRequest = {
      url: "auth/login",
      data: {
        email,
        password,
      },
      config: {},
    };

    postApi(apiCallRequest)
      .then((res) => {
        let user = res.data;
        let apiCallRequest = {
          url: `/clients/byuserid/` + user.id,
          data: {},
          config: {
            headers: {
              Authorization: "Bearer " + user.token,
            },
          },
        };
        var companyId;
        getApi(apiCallRequest)
          .then((response) => {
            let client = response.data;
            companyId = client.companyId;
            const apiCallRequestClient = {
              url: `/gcp/getCampaign/` + client.companyId,
              data: {},
              config: {
                headers: {
                  Authorization: "Bearer " + user.token,
                },
              },
            };
            getApi(apiCallRequestClient)
              .then(async (response) => {
                let companyData = response.data.company;
                let campaignLength = response.data.campaigns.length;
                if (
                  campaignLength == 1 &&
                  response.data.campaigns[0].id == null
                ) {
                  // Have to update in backend API
                  campaignLength = 0;
                }

                let obj = {
                  token: user.token,
                  userId: user.id,
                  name: user.name,
                  campaigns: campaignLength,
                  userType: user.userType,
                  email: user.email,
                  phone: user.phone,
                  companyId,
                };

                let planType = companyData?.industry_type;
                let startData = companyData?.createdAt;

                let userType = user.userType;
               
                userType = userType?.toLowerCase();
                planType = planType?.toLowerCase();

                if (userType === "free") {
                  const dates = await getStartEndDate(startData, "days", 15);
                  dispatch(
                    success(response.data.campaigns, obj, planType, dates)
                  );
                } else if (userType === "standard") {
                  let isValid = planType === "quarterly" ? 3 : 12;
                  const dates = await getStartEndDate(
                    startData,
                    "months",
                    isValid
                  );
                  // console.log(dates, "standard qua");
                  dispatch(
                    success(response.data.campaigns, obj, planType, dates)
                  );
                } else if (userType === "premium") {
                  let isValid = planType === "quarterly" ? 3 : 12;
                  const dates = await getStartEndDate(
                    startData,
                    "months",
                    isValid
                  );
                  // console.log(dates, "premium qua");
                  dispatch(
                    success(response.data.campaigns, obj, planType, dates)
                  );
                } else {
                  dispatch(failure("Invalid Email or Password!"));
                }
              })
              .catch((err) => {
                dispatch(failure(err.message));
              });
          })
          .catch((err) => {
            dispatch(failure(err.message));
          });
      })
      .catch((error) => {
        if (error.message === "Network Error") {
          dispatch(failure("Network Error!"));
        } else {
          dispatch(failure("Invalid Email or Password!"));
        }
      });

    function request(name) {
      return { type: userConstants.LOGIN_REQUEST, name };
    }

    function success(campaigns, client, planType, campaignDates) {
      return {
        type: userConstants.LOGIN_SUCCESS,
        payload: {
          campaigns,
          client,
          planType,
          campaignDates,
        },
      };
    }
    function failure(error) {
      return { type: userConstants.LOGIN_FAILURE, error };
    }
  };

const logout = () => (dispatch) => {
  dispatch({
    type: userConstants.LOGOUT,
    payload: {
      step: 1,
    },
  });
};

export { login, logout };
